import type { Reminder } from '@/core/domain';

/** YYYY-MM-DD a partir de ISO completo ou só data. */
export function isoToDateKey(iso: string): string {
  const t = iso.trim();
  if (t.length >= 10) return t.slice(0, 10);
  return t;
}

export function normalizeSentAt(sentAt: string[] | string | null | undefined): string[] {
  if (Array.isArray(sentAt)) return sentAt;
  if (typeof sentAt === 'string') return [sentAt];
  return [];
}

export function isLembreteEnviado(sentAt: string[] | string | null | undefined): boolean {
  return normalizeSentAt(sentAt).length > 0;
}

/** Lembrete teve pelo menos um envio (sent_at) neste dia (calendário local). */
export function reminderHadSendOnDay(r: Reminder, dayKey: string): boolean {
  return normalizeSentAt(r.sent_at).some((s) => isoToDateKey(s) === dayKey);
}

/**
 * Coorte do dia: avisos com envio registrado em `dayKey`, para métricas tipo funil.
 */
export function cohortForSendDay(reminders: Reminder[], dayKey: string): Reminder[] {
  return reminders.filter((r) => isLembreteEnviado(r.sent_at) && reminderHadSendOnDay(r, dayKey));
}

export interface DayFunnelMetrics {
  total: number;
  contacted: number;
  scheduled: number;
}

/** Quantidade de lembretes futuros cuja data prevista de manutenção cai em `dayKey`. */
export function countFutureRemindersOnDay(futuros: Reminder[], dayKey: string): number {
  return futuros.filter((r) => isoToDateKey(r.expected_date) === dayKey).length;
}

export function funnelMetricsForDay(reminders: Reminder[], dayKey: string): DayFunnelMetrics {
  const cohort = cohortForSendDay(reminders, dayKey);
  const total = cohort.length;
  const contacted = cohort.filter(
    (r) => r.contacted_at != null && String(r.contacted_at).trim() !== ''
  ).length;
  const scheduled = cohort.filter(
    (r) => r.scheduled_date != null && String(r.scheduled_date).trim() !== ''
  ).length;
  return { total, contacted, scheduled };
}

/** Lembrete com `scheduled_date` preenchido (manutenção agendada pelo dono). */
export function hasScheduledMaintenance(r: Reminder): boolean {
  return r.scheduled_date != null && String(r.scheduled_date).trim() !== '';
}

export function filterScheduledMaintenanceReminders(reminders: Reminder[]): Reminder[] {
  return reminders.filter(hasScheduledMaintenance);
}

export function countScheduledMaintenanceOnDay(reminders: Reminder[], dayKey: string): number {
  return reminders.filter(
    (r) => hasScheduledMaintenance(r) && isoToDateKey(r.scheduled_date!) === dayKey
  ).length;
}

export function scheduledMaintenanceOnDay(reminders: Reminder[], dayKey: string): Reminder[] {
  return reminders.filter(
    (r) => hasScheduledMaintenance(r) && isoToDateKey(r.scheduled_date!) === dayKey
  );
}
